import { createFileRoute } from '@tanstack/react-router';
import EmailDownload from '../../components/EmailDownload';

/**
 * Report Download Route
 *
 * Handles email report downloads via URL parameter (job ID)
 * No Layout wrapper - standalone download page
 */
export const Route = createFileRoute('/report/download/$id')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ReportDownloadRoute,
});

function ReportDownloadRoute() {
  // The EmailDownload component extracts the ID from window.location.pathname
  // This maintains compatibility with existing implementation
  return <EmailDownload />;
}
